/**
 * sleep function by default 5sec 
 * @param time 
 * @returns 
 */
async function sleep(miliseconds: number = 5e3) {
    return new Promise((res: any, rej: any) => {
        setTimeout(() => {
            res(true)
        }, (miliseconds));
    })
}


function isArrayNotEmpty(arr: any[]) {
    try {
        return Array.isArray(arr) && arr.length ? true : false;
    } catch (error) {
        return false;
    }
}


function jsonParse(jsonStr: string) {
    return JSON.parse(jsonStr)
}


function blob2ToBlob(blobarr, type) {
    return new Blob([blobarr], { type: type });
}

function StringifyJson(value: any) {
    return JSON.stringify(value);
}

export const CommonUtils = {
    sleep,
    isArrayNotEmpty,
    jsonParse,
    blob2ToBlob,
    StringifyJson
}